// File: src/pages/organization/Dashboard.tsx
import React from 'react';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import { useUser } from '@/contexts/UserContext';

const OrganizationDashboard: React.FC = () => {
  const { loading } = useUser();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <Typography variant="h4" gutterBottom>
          Organization Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          The organization management features are currently being redesigned for better usability and functionality.
          Please check back soon for updates.
        </Typography>
      </Box>
    </Container>
  );
};

export default OrganizationDashboard;